import { Stack, Typography } from "@mui/material";
import { DynamicCatalogBuilder } from "../../../../../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { interWarehouseGetPartListAPICall } from "../../services/apiCall";
import { InterWarehouseTransferRequisitionKeys } from "../../services/entity";
export var AddedParts = function (props) {
    var id = props.id;
    var itemDetailsColumns = [{
            field: 'ProductName',
            headerName: 'Part name & code',
            flex: 1,
            renderCell: function (params) {
                var _params$row$ProductNa, _params$row, _params$row$SkuCode, _params$row2;
                return /*#__PURE__*/ React.createElement(Stack, {
                    height: '100%',
                    justifyContent: "center"
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption"
                }, (_params$row$ProductNa = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ProductName) !== null && _params$row$ProductNa !== void 0 ? _params$row$ProductNa : '-'), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: "secondary"
                }, (_params$row$SkuCode = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.SkuCode) !== null && _params$row$SkuCode !== void 0 ? _params$row$SkuCode : '-'));
            }
        }, {
            field: 'UnitOfMeasurementName',
            headerName: 'UOM',
            minWidth: 100
        }, {
            field: 'AvailableQuantity',
            headerName: 'Available Qty',
            minWidth: 100
        }, {
            field: 'SL',
            headerName: 'Storage Locations (s)',
            minWidth: 100
        }, {
            field: 'RequestedQuantity',
            headerName: 'Transfer Qty',
            minWidth: 100
        }];
    return /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        columns: itemDetailsColumns,
        dataGridProps: {
            getRowHeight: function () { return 52; },
            hideFooter: true
        },
        pagingAPIRequest: {
            StockTransferRequisitionId: id
        },
        getPagingData: interWarehouseGetPartListAPICall,
        pagingAPIKey: InterWarehouseTransferRequisitionKeys.GetPartList
    }));
};
